import { Controller } from "@hotwired/stimulus";
import { loadFilePond } from "../models/filepond_loader";

export default class StripPostController extends Controller {
  static targets = ["postList", "locationButton"];
  static values = {
    showReplies: Boolean
  };

  connect() {
    if (this.element.matches("form")) {
      this.handleTurboBeforeCache =
        this.preparePostFormForCache.bind(this);

      document.addEventListener(
        "turbo:before-cache",
        this.handleTurboBeforeCache
      );

      globalThis.addEventListener(
        "pagehide",
        this.handleTurboBeforeCache
      );
    }

    loadFilePond().then((FilePond) => {
      this.FilePond = FilePond;

      if (this.showRepliesValue) {
        this.toggleReplies(true);
      }
    });
  }

  disconnect() {
    this.observer?.disconnect();
    if (!this.handleTurboBeforeCache) return;

    document.removeEventListener(
      "turbo:before-cache",
      this.handleTurboBeforeCache
    );
    globalThis.removeEventListener(
      "pagehide",
      this.handleTurboBeforeCache
    );
  }

  preparePostFormForCache() {
    if (!this.FilePond) return;

    this.element.dataset.filePondCacheSuspended = "true";

    const ponds = Array.from(
      this.element.querySelectorAll(
        "input[id^='post_medias_'], .filepond--root"
      )
    )
      .map(element => this.FilePond.find(element))
      .filter((pond, index, list) => pond && list.indexOf(pond) === index);

    for (const pond of ponds) pond.destroy();

    for (const input of this.element.querySelectorAll("input[id^='post_medias_']")) {
      input.classList.add("d-none");
    }
  }

  post_form(e) {
    // $(e.target).atwho({
    //   at: '@',
    //   data: '/posts/get_mention_users',
    //   displayTpl: '<li>${name}</li>',
    //   insertTpl: ' ${display_name} ',
    //   delay: 400
    // })

    $(".post_submit").removeClass("disabled");
    $(".plus_button").removeClass("d-none").show();

    if ($("#shareRecipeModal").is(":visible")) {
      let field = $("#shareRecipeModal")
        .find("form")
        .find(".post-field:not(':focus')")
        .each(function (index, element) { });
      $("#shareRecipeModal")
        .find("form")
        .find(document.activeElement)
        .parent("div")
        .parent("div")
        .find(".post_media")
        .removeClass("d-none");
      field.parent("div").parent("div").find(".post_media").addClass("d-none");
    } else {
      $(document.activeElement)
        .parent("div")
        .parent("div")
        .find(".post_media")
        .removeClass("d-none");
    }
  }

  open_modal(e) {
    const trigger = e.currentTarget;
    if (trigger.classList.contains("disabled")) {
      e.preventDefault();
      return;
    }

    $("#sentLoader").toggleClass("d-none");
    $(trigger).find("svg").toggleClass("d-none");
    let truck_modal = document.getElementById("addPostModal");
    const modal = bootstrap.Modal.getInstance(truck_modal);
    if (modal._isShown) return;

    const currentModalElement = trigger.closest(".modal");
    if (currentModalElement) {
      const currentModal = bootstrap.Modal.getInstance(currentModalElement);
      if (currentModal) {
        currentModal.hide();
      }
    }

    $("#sharePostOptions").remove();
    let extras = e.target.dataset.extras || "";
    e.preventDefault();
    let form = document.getElementById("new_post_form");
    let extraHtml = document.createElement("input");
    extraHtml.type = "hidden";
    extraHtml.name = "post[extra_description]";
    extraHtml.value = extras;
    form.append(extraHtml);
    if ($(form).valid()) {
      form.requestSubmit();
      form.addEventListener("turbo:submit-end", (submitEvent) => {
        submitEvent.stopPropagation();
        modal.show();

        setTimeout(() => {
          $("#sentLoader").toggleClass("d-none");
          $(trigger).find("svg").toggleClass("d-none");
        }, 1000);
      }, { once: true });
    } else {
      $(form)[0].querySelector("#not_ignore").value = "";
      delete $(form)[0].querySelector("#not_ignore")?.dataset?.fired;
    }
  }

  addReplyForm(e) {
    const $reply = $(e.currentTarget)
      .closest(".comment-list")
      .find(".commentReply");

    $reply.toggleClass("d-none");
    if ($reply.hasClass("d-none")) return;

    const $field = $reply.find(".comment_field");

    const quillElement = $field.closest("[data-controller~=\"quill\"]").get(0);
    if (!quillElement) return;

    const quillController = this.application.getControllerForElementAndIdentifier(quillElement, "quill");
    if (!quillController?.quill) return;

    requestAnimationFrame(() => {
      quillController.focusInput();
      quillElement.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
  }

  hideReplyForm(e) {
    $(e.currentTarget).find(".commentReply").addClass("d-none");
    const pond = this.FilePond.find(
      $(e.currentTarget)
        .closest(".comment-list")
        .find(".commentReply")
        .find(".filepond-transparent")[0]
    );
    // remove the GIF attachment from media field after click on post button of reply comment
    if (pond) pond.removeFile();
    setTimeout(() => {
      $(".comment_field").find(".ql-editor").html("");
    }, 500);
  }

  removeComment(e) {
    setTimeout(() => {
      $(".comment_reply").find(".ql-editor").html("");
    }, 500);
  }

  showReplyList(e) {
    e.preventDefault();
    this.toggleReplies();
  }

  hideReplyList(e) {
    e.preventDefault();

    const commentId = this.element.dataset.id;
    const replies = $(`#comment_${commentId} .comment`).slice(1);
    const hideReply = document.getElementById(`replies_display_${commentId}`);
    const viewRepliesLink = document.querySelector(`.view_reply_${commentId}`);
    const viewReplies = document.getElementById(`view_replies_${commentId}`);

    replies.addClass("d-none");

    // Show "View Replies"
    viewRepliesLink?.classList.remove("d-none");
    viewReplies?.classList.remove("d-none");

    // Hide "Hide replies"
    hideReply?.classList.add("d-none");
  }

  toggleReplies(forceShow = null) {
    const commentId = this.element.dataset.id;
    const replies = $(`#comment_${commentId} .comment`).slice(1);
    const link = document.getElementById(`show_reply_${commentId}`);
    const hideReply = document.getElementById(`replies_display_${commentId}`);
    const viewRepliesLink = document.querySelector(`.view_reply_${commentId}`);
    const viewReplies = document.getElementById(`view_replies_${commentId}`);

    const shouldShow = forceShow == null ? replies.hasClass("d-none") : forceShow;
    replies.toggleClass("d-none", !shouldShow);

    // When replies are visible
    if (shouldShow) {
      viewRepliesLink?.classList.add("d-none");
      viewReplies?.classList.add("d-none");
      hideReply?.classList.remove("d-none");
      link?.classList.remove("d-none");
    } else {
      // When replies are hidden
      viewRepliesLink?.classList.remove("d-none");
      viewReplies?.classList.remove("d-none");
      hideReply?.classList.add("d-none");
      link?.classList.add("d-none");
    }

    globalThis.requestAnimationFrame(() => {
      const scrollTarget = shouldShow
        ? link || hideReply
        : viewReplies || viewRepliesLink;

      scrollTarget?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    });
  }

  change_show_type(event) {
    const nestedForm = this.element.querySelector("[data-controller=\"nested-form\"]");
    const target = event.currentTarget;

    if (nestedForm) {
      const groups = this.element.querySelectorAll(".dropdown.share-post-options");

      for (const dropdown of groups) {
        const dropdownMenu = dropdown.querySelector(".dropdown-menu");
        if (!dropdownMenu) continue;

        const checkboxes = dropdownMenu.querySelectorAll(".form-check-input");

        const currentCheckbox = Array.from(checkboxes).find(
          (cb) => cb.dataset.option === target.dataset.option
        );

        if (!currentCheckbox) continue;

        currentCheckbox.checked = target.checked;

        const everyoneCheckbox = Array.from(checkboxes).find(
          (cb) => cb.dataset.option === "everyone"
        );
        const onlyMeCheckbox = Array.from(checkboxes).find(
          (cb) => cb.dataset.option === "only_me"
        );

        handleExclusiveSelection(
          target.dataset.option,
          checkboxes,
          everyoneCheckbox,
          onlyMeCheckbox
        );

        const selectedOptions = Array.from(checkboxes)
          .filter((cb) => cb.checked)
          .map((cb) =>
            cb.dataset.option === "clan"
              ? "Clan"
              : cb.nextElementSibling?.textContent.trim()
          );

        dropdown.querySelector(".share_types").textContent =
          selectedOptions.join(", ") || "Select Share Options";
      }

      return;
    }

    // Existing flow
    const selectedValue = target.dataset.option;
    const dropdownMenu = target.closest(".dropdown-menu.share-post-options");
    const dropdown = dropdownMenu?.closest(".dropdown");

    const shareTypesSpan = dropdown?.querySelector(".share_types");
    const checkboxes = dropdownMenu?.querySelectorAll(".form-check-input") || [];

    const everyoneCheckbox = Array.from(checkboxes).find(
      (cb) => cb.dataset.option === "everyone"
    );
    const onlyMeCheckbox = Array.from(checkboxes).find(
      (cb) => cb.dataset.option === "only_me"
    );

    handleExclusiveSelection(
      selectedValue,
      checkboxes,
      everyoneCheckbox,
      onlyMeCheckbox
    );

    const selectedOptions = Array.from(checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) =>
        cb.dataset.option === "clan"
          ? "Clan"
          : cb.nextElementSibling?.textContent.trim()
      );

    shareTypesSpan.textContent =
      selectedOptions.join(", ") || "Select Share Options";

    if (event.target?.dataset?.submit && selectedOptions.length > 0) {
      event.target.closest("form")?.requestSubmit();
    } else if (event.target?.dataset?.submit) {
      target.checked = true;
      shareTypesSpan.textContent = target.dataset.option;
    }
  }

  selectFile(e) {
    e.preventDefault();
    const mediaButton = e.currentTarget;
    const index = e.currentTarget.dataset.index;
    const target = document.getElementById(`post_medias_${index}`);
    const dismissMediaTooltip = () => {
      globalThis.bootstrap?.Tooltip
        .getInstance(mediaButton)
        ?.hide();
      mediaButton.blur();
      mediaButton.removeAttribute("aria-describedby");
    };

    dismissMediaTooltip();
    if (!target) return;

    target.classList.remove("d-none");
    const pond = this.FilePond?.find(target);

    // FilePond initializes asynchronously. Preserve the user's click by
    // opening the native input if the instance is not registered yet.
    if (!pond) {
      target.click();
      return;
    }

    // After browser closes, wait a tick and check whether a file was selected
    const onFocus = () => {
      globalThis.removeEventListener("focus", onFocus);
      dismissMediaTooltip();

      // Let FilePond finish processing selected files
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          dismissMediaTooltip();

          if (pond.getFiles().length === 0) {
            target.classList.add("d-none");
          }
        });
      });
    };

    globalThis.addEventListener("focus", onFocus, { once: true });
    pond.browse();
  }

  deletePost(event) {
    event.preventDefault();
    let id = $(this.element).find(".delete-post").attr("data-id");
    Swal.fire({
      customClass: {
        popup:
          "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        fetch("/posts/" + id, {
          method: "DELETE",
          headers: {
            Accept: "text/vnd.turbo-stream.html",
            "Content-Type": "application/json"
          }
        })
          .then((r) => r.text())
          .then((response) => {
            globalThis.location.href = "/posts";
            Turbo.renderStreamMessage(response);
          });
      }
    });
  }

  createPoll(e) {
    let target = e.currentTarget;
    let index = target.dataset.index;
    $("#post-poll-" + index).removeClass("d-none");
    $(
      "input[name='user[posts_attributes][" +
      index +
      "][post_poll_attributes][_destroy]']"
    ).val(false);
    $(e.target).closest("form").find("#pollBtn").addClass("disabled");
    this.hideAllTooltip();
    this.updateQuillContentState(index);
  }

  async removePoll(e) {
    let target = e.currentTarget;
    let index = target.dataset.index;
    const result = await this.showAlert("Confirmation", "Are you sure you want to remove this poll?", "warning");
    if (result.isConfirmed) {
      $(`#post-poll-${index}`).addClass("d-none");
      $(`input[name='user[posts_attributes][${index}][post_poll_attributes][_destroy]']`).val(true);

      let description = $(`div[data-name='user[posts_attributes][${index}][description]']`).find(".ql-editor");
      $(`input[name='user[posts_attributes][${index}][description]']`).val(description?.html());

      const addedOptions = $(`#post-poll-${index}`).find("[data-action=\"click->nested-form#remove_association\"]").closest(".nested-fields");
      addedOptions.remove();

      $(`#post-poll-${index} .nested-fields input`).val("");
      $(`#post-poll-${index}`).find(".add_options").removeClass("d-none");
      $(target).closest("form").find("#pollBtn").removeClass("disabled");
      this.updateQuillContentState(index);
    }
  }

  // on create and remove poll handle the submit button state
  updateQuillContentState(index) {
    const quillElement = $(
      `div[data-name='user[posts_attributes][${index}][description]']`
    )[0];

    if (!quillElement) return;

    const quillController =
      this.application.getControllerForElementAndIdentifier(
        quillElement,
        "quill"
      );

    quillController?.updateContentState();
  }

  postPollFields(e) {
    const wrapper = e.currentTarget.closest(".post-form-wrapper");
    if (!wrapper) return;

    const day = wrapper.querySelector(".day-field")?.value;
    const hr = wrapper.querySelector(".hr-field")?.value;
    const minSelect = wrapper.querySelector(".min-field");
    if (!minSelect) return;

    const shouldEnableMinutes = day != 0 || hr != 0;

    for (let i = 0; i < 5; i++) {
      minSelect.options[i].disabled = !shouldEnableMinutes;
    }

    if (!shouldEnableMinutes) {
      minSelect.value = 5;
      $(minSelect).trigger("change");
    }
  }

  timeChanged(e) {
    const value = e.target.value?.trim();

    if (!value) {
      this.clearPendingSchedule(e.currentTarget);
      return;
    }

    // Expected format: YYYY-MM-DD HH:MM AM/PM
    // Example: 2026-08-20 05:30 PM
    const match = value.match(
      /^(\d{4})-(\d{2})-(\d{2}) (\d{1,2}):(\d{2}) (AM|PM)$/i
    );

    if (!match) {
      console.error("Invalid date format:", value);
      return;
    }

    const [, year, month, day, hourValue, minute, meridiem] = match;

    let hour = Number(hourValue);
    const numericYear = Number(year);
    const numericMonth = Number(month);
    const numericDay = Number(day);
    const numericMinute = Number(minute);

    // Validate basic ranges
    if (
      numericMonth < 1 ||
      numericMonth > 12 ||
      numericDay < 1 ||
      numericDay > 31 ||
      hour < 1 ||
      hour > 12 ||
      numericMinute < 0 ||
      numericMinute > 59
    ) {
      console.error("Invalid date/time:", value);
      return;
    }

    // Convert 12-hour time to 24-hour time
    hour = hour % 12;

    if (meridiem.toUpperCase() === "PM") {
      hour += 12;
    }

    const time = new Date(
      numericYear,
      numericMonth - 1,
      numericDay,
      hour,
      numericMinute
    );

    // Validate actual date
    // Example: prevents 2026-02-31 becoming March automatically
    if (
      Number.isNaN(time.getTime()) ||
      time.getFullYear() !== numericYear ||
      time.getMonth() !== numericMonth - 1 ||
      time.getDate() !== numericDay
    ) {
      console.error("Invalid date:", value);
      return;
    }

    // Display format:
    // Example: Aug 20, 2026, 05:30 PM
    const display = time.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });

    // Value format:
    // Example: 2026-08-20T17:30
    const pad = number => String(number).padStart(2, "0");

    const isoWithoutSeconds =
      `${numericYear}-${pad(numericMonth)}-${pad(numericDay)}` +
      `T${pad(hour)}:${pad(numericMinute)}`;

    e.currentTarget.dataset.pendingScheduledAt = isoWithoutSeconds;
    e.currentTarget.dataset.pendingScheduleDisplay = display;
    e.currentTarget
      .closest(".modal")
      ?.querySelector(".confirm-schedule-button")
      ?.classList.remove("disabled");
  }

  confirmSchedule(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.classList.contains("disabled")) return;

    const index = button.dataset.index;
    const dateInput = button
      .closest(".modal")
      ?.querySelector(`[data-index="${index}"][data-flatpickr-type-value="datetime"]`);
    const scheduledAt = dateInput?.dataset.pendingScheduledAt;
    const display = dateInput?.dataset.pendingScheduleDisplay;

    if (!scheduledAt || !display) return;

    $(`#set_schedule_time_${index}`).removeClass("d-none");
    $(`#schedule_time_${index}`).text(display);
    $(`#scheduled_at_${index}`).val(scheduledAt);

    // Pending value is now committed
    delete dateInput.dataset.pendingScheduledAt;
    delete dateInput.dataset.pendingScheduleDisplay;
  }

  updateLocationButton(input) {
    const modal = input.closest(".modal");
    const button = modal?.querySelector("[data-strip-post-target=\"locationButton\"]");

    if (!button) return;

    button.disabled = input.value.length === 0;
  }

  locationChanged(event) {
    const input = event.target;

    if (event.type === "location-selected") {
      input.dataset.selectedValue = input.value;
      input.setCustomValidity("");
    } else {
      delete input.dataset.selectedValue;
      input.setCustomValidity("Please select a location from the suggestions.");
    }

    this.updateLocationButton(input);
  }

  openLocationModal(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.classList.contains("disabled")) {
      return;
    }

    const index = event.currentTarget.dataset.index;
    this.element.dataset.index = index;

    const modalElement = document.getElementById(`locationModal${index}`);
    if (modalElement) {
      const input = modalElement.querySelector(`#postLocation_${index}`);

      if (input) {
        input.dataset.originalValue = input.value;
        this.updateLocationButton(input);
      }

      new bootstrap.Modal(modalElement).show();
    } else {
      console.error("Location modal target not found!");
    }
    this.hideAllTooltip();
  }

  openSchedule(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    this.element.dataset.index = index;

    const modalElement = document.getElementById(`dateTimeModal${index}`);
    if (!modalElement) {
      console.error("Schedule modal target not found!");
      return;
    }

    const modal = bootstrap.Modal.getOrCreateInstance(modalElement);

    const dateField = modalElement.querySelector(`[data-index="${index}"][data-flatpickr-type-value="datetime"]`);

    const scheduledField = document.getElementById(`scheduled_at_${index}`);

    if (dateField && scheduledField) {
      const savedValue = scheduledField.value;
      // Clear any previous unconfirmed selection
      delete dateField.dataset.pendingScheduledAt;
      delete dateField.dataset.pendingScheduleDisplay;
      if (savedValue) {
        // Restore the LAST CONFIRMED value
        const flatpickr = dateField._flatpickr;
        if (flatpickr) {
          flatpickr.setDate(savedValue, false);
        } else {
          dateField.value = savedValue;
        }
        // Enable OK because there is already a confirmed value
        modalElement.querySelector(".confirm-schedule-button")?.classList.remove("disabled");
      } else {
        if (dateField._flatpickr) {
          dateField._flatpickr.clear();
        } else {
          dateField.value = "";
        }
        modalElement.querySelector(".confirm-schedule-button")?.classList.add("disabled");
      }
    }

    modal.show();
    this.hideAllTooltip();
  }

  setLocation(e) {
    const idx = e.currentTarget.dataset.index;
    if (idx) {
      const input = document.getElementById(`postLocation_${idx}`);
      const val = input?.value?.trim();

      if (!val || val !== input.dataset.selectedValue) {
        const placesController = this.application.getControllerForElementAndIdentifier(input?.closest("[data-controller~=\"places\"]"), "places");
        placesController?.showLocationError(
          val
            ? "No matching location found. Please select a location from the suggestions."
            : "Please select a location from the suggestions."
        );

        input?.focus();
        return;
      }

      input.setCustomValidity("");
      $(`#location_${idx}`).html(`
        <div class="text-black-paint text-white fs-20 p-font-bold py-2" id="location-1-${idx}">
          <span class="text-white">${val}</span>
          <span class="ms-2">
            <a class="text-danger cursor-pointer" data-action="strip-post#removeLocation" data-key="1" data-index="${idx}">x</a>
          </span>
          <input type="hidden" value="${val}" name="user[posts_attributes][${idx}][location]">
        </div>
      `);

      const modalElement = document.getElementById(`locationModal${idx}`);

      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        modal?.hide();
      }
    }
  }

  removeLocation(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    const key = event.currentTarget.dataset.key;
    $(`#location-${key}-${index}`).remove();
    const input = document.getElementById(`postLocation_${index}`);
    if (input) {
      input.value = "";
      input.dataset.originalValue = "";
      delete input.dataset.selectedValue;
      input.setCustomValidity("");
      this.updateLocationButton(input);
    }
  }

  async checkForm(e) {
    e.preventDefault();
    const postSection = this.element;
    $(postSection).addClass("disabled");
    const button = e.currentTarget;
    const form = button.closest("form");

    const hasShareOption =
      $(form).find(
        "[name^='user[posts_attributes]'][name$='[share_post_option][]']:checked"
      ).length > 0;

    const hasPostDropdown =
      $(form).find(".post-dropdown").length > 0;

    if (!hasShareOption && hasPostDropdown) {
      alert("Please select at least one share option.");
      $(postSection).removeClass("disabled");
      return;
    }

    // validate poll posts
    const pollOptionsCards = $(form).find("[id^=\"post-poll-\"]:visible");
    for (const pollOptionsCard of pollOptionsCards) {
      const options = $(pollOptionsCard)
        .find(".nested-fields")
        .filter(":visible")
        .find("input.custom-form-control");

      for (const option of options) {
        if (!option.value.trim()) {
          alert("Please enter all poll options.");
          $(postSection).removeClass("disabled");
          return;
        }
      }
    }

    // validate all nested posts
    const nestedForms = $(form).find(".post-form-wrapper");
    if (nestedForms.length > 1) {
      const hasInvalidForm = nestedForms.toArray().some(wrapper => {
        const submitButton = $(wrapper).find("button[type=\"submit\"], input[type=\"submit\"]");

        return submitButton.length && submitButton.prop("disabled");
      });

      if (hasInvalidForm) {
        alert("All post must have description or media.");
        $(postSection).removeClass("disabled");
        return;
      }
    }

    const filePondTarget =
      document.getElementById(`post_medias_${button.dataset?.index}`) ||
      document.getElementById("new_message");

    const filePond = filePondTarget ? this.FilePond.find(filePondTarget) : null;
    const closeIcon = form.querySelector(".close-form");
    const mediaButtons = form.querySelectorAll(".emoji-mart-dropdown, .add_post, .media-options .btn");

    const cleanup = (resetEditor = false) => {
      $(postSection).removeClass("disabled");
      button.classList.remove("disabled", "loading");
      button.disabled = false;
      button.querySelector(".button-loader-spinner")?.classList.add("d-none");
      if (closeIcon) closeIcon.classList.remove("disabled");

      for (const btn of mediaButtons) {
        btn.disabled = false;
        btn.classList.remove("disabled", "loading");
      }

      if (resetEditor) {
        this.resetQuillInput();
        filePond?.removeFiles();
      }
    };

    try {
      if (filePond) {
        button.querySelector(".button-loader-spinner")?.classList.remove("d-none");
        button.classList.add("loading", "disabled");
        button.disabled = true;
        button.querySelector(".button-loader-spinner")?.classList.remove("d-none");
        // Direct uploads already provide signed attachment IDs to the form.
        if (!filePondTarget.dataset.directUploadUrl) {
          await filePond.prepareFiles();
        }
      }
    } catch {
      alert("Files preparation failed.");
      cleanup();
      return;
    }

    button.classList.add("disabled", "loading");
    button.disabled = true;
    button.querySelector(".button-loader-spinner")?.classList.remove("d-none");

    if (closeIcon) closeIcon.classList.add("disabled");
    for (const btn of mediaButtons) {
      btn.disabled = true;
      btn.classList.add("disabled");
    }

    // jQuery validation
    const validator = $(form).data("validator");

    if (validator && !validator.form()) {
      cleanup();
      return;
    }

    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.value = true;
    hiddenField.setAttribute("name", "create");
    this.element.closest("form").appendChild(hiddenField);

    this._submitEndHandler = (event) => {
      cleanup(event.detail.success === true);

      form.removeEventListener(
        "turbo:submit-end",
        this._submitEndHandler
      );

      this._submitEndHandler = null;
    };

    form.addEventListener(
      "turbo:submit-end",
      this._submitEndHandler,
      { once: true }
    );

    form.requestSubmit();
    const formSubmissionController =
      this.application.getControllerForElementAndIdentifier(
        form,
        "form-submission"
      );

    if (
      formSubmissionController
    ) {
      formSubmissionController.start();
    }
  }

  // Called when Stimulus target "postList" is connected to DOM
  postListTargetConnected(posts) {
    this.observer?.disconnect();
    this.postsContainer = posts;
    this.mutationObserver(posts);
  }

  postListTargetDisconnected() {
    this.observer?.disconnect();
  }

  mutationObserver(posts) {
    // Cursor pagination already appends posts in feed order. Watch only direct
    // frame replacements that change pin state; reordering every appended page
    // removes and reinserts the full feed and causes blank frames while scrolling.
    const config = { childList: true, subtree: false };

    this.observer = new MutationObserver((mutationsList) => {
      const addedFrames = new Map();
      const removedFrames = new Map();

      for (const mutation of mutationsList) {
        if (mutation.type !== "childList") continue;

        for (const node of mutation.addedNodes) {
          if (node instanceof HTMLElement && node.matches(".repost_list_frame")) {
            addedFrames.set(node.id, node);
          }
        }

        for (const node of mutation.removedNodes) {
          if (node instanceof HTMLElement && node.matches(".repost_list_frame")) {
            removedFrames.set(node.id, node);
          }
        }
      }

      // Pagination only adds frames. Reorder exclusively when Turbo replaces
      // an existing frame and the old or new frame affects feed ordering.
      const shouldReorder = Array.from(addedFrames).some(([id, added]) => {
        const removed = removedFrames.get(id);
        if (!removed) return false;

        // Turbo append can replace duplicate IDs at page boundaries. Replacing
        // a repost is not a pin change and must not reorder the loaded feed.
        return added.classList.contains("pinned_post") !==
          removed.classList.contains("pinned_post");
      });

      if (shouldReorder) {
        this.reorderPosts(posts);
      }
    });

    this.observer.observe(posts, config);
  }

  reorderPosts(container) {
    // Collect all post elements currently in DOM
    const allPosts = Array.from(
      container.querySelectorAll(":scope > .repost_list_frame")
    );
    if (allPosts.length === 0) return;

    const pinned = [];
    const normal = [];

    // Separate pinned and normal posts (NO DOM removal)
    for (const post of allPosts) {
      if (post.classList.contains("pinned_post")) {
        pinned.push(post);
      } else {
        normal.push(post);
      }
    }

    // Sort normal posts by timestamp (newest first)
    normal.sort((a, b) => {
      const aTime = Number(a.querySelector(".post-time")?.dataset?.time || 0);
      const bTime = Number(b.querySelector(".post-time")?.dataset?.time || 0);
      return bTime - aTime;
    });

    const finalOrder = [...pinned, ...normal];
    if (allPosts.every((post, index) => post === finalOrder[index])) return;

    this.observer.disconnect(); // Temporarily disable observer to prevent infinite loop during DOM updates

    try {
      // Preserve existing cards and their media controllers wherever possible.
      // Never empty the list while the user is scrolling through it.
      let current = allPosts[0];
      for (const post of finalOrder) {
        if (post !== current) current.before(post);
        current = post.nextElementSibling;
        while (current && !current.matches(".repost_list_frame")) {
          current = current.nextElementSibling;
        }
      }
    } finally {
      this.observer.observe(container, { childList: true, subtree: false });
    }
  }

  removePreview(e) {
    const previewEle = e.target.closest(".preview-link");
    const linkThumb = previewEle.parentElement;
    const urlEle = linkThumb.nextElementSibling;
    urlEle.value = "";
    urlEle.nextElementSibling.value = false;
    previewEle.remove();
  }

  hideAllTooltip() {
    setTimeout(() => {
      for (const tooltip of document.querySelectorAll(".tooltip")) {
        tooltip.remove();
      }
    }, 50);
  }

  openForm(event) {
    $("#post-form").addClass("d-none");
    $("#post_section").removeClass("d-none");

    const element = event.currentTarget.dataset.element;
    const btn = element ? document.getElementById(element) : null;

    if (btn) {
      setTimeout(() => {
        btn.click();
      }, 100);
    } else {
      const quillElement = document.querySelector("#post_section [data-controller~=\"quill\"]");
      const quillController = quillElement && this.application.getControllerForElementAndIdentifier(quillElement, "quill");
      requestAnimationFrame(() => {
        quillController?.focusInput();
      });

    }
  }

  async closeForm(event) {
    const index = event.currentTarget.dataset.index;
    const form = event.currentTarget.closest("form");

    const target =
      document.getElementById(`post_medias_${index}`) ||
      document.getElementById("new_message");

    const FilePond = await loadFilePond();
    const filePond = target ? FilePond.find(target) : null;

    setTimeout(async () => {
      // reset normal form fields
      if (form) form.reset();

      this.updateSharePostDisplay(form, index);
      this.updateReplyOptionDisplay(form);

      // reset quill editor
      this.resetQuillInput();
      // remove filepond files
      if (filePond) {
        await filePond.removeFiles();
      }

      $(`#location_${index}`).html("");
      $(`#schedule_time_${index}`).text("");
      $(`#scheduled_at_${index}`).val("");
      $(`#post-poll-${index}`).addClass("d-none");
      $("#post-form").removeClass("d-none");
      $("#post_section").addClass("d-none");
      $("#pollBtn").removeClass("disabled");

      await new Promise(resolve => requestAnimationFrame(resolve));

      const formSubmissionController = form
        ? this.application.getControllerForElementAndIdentifier(
          form,
          "form-submission"
        )
        : null;

      formSubmissionController?.markClean();
    }, 100);
  }

  async resetPostForm() {
    const form = this.element.matches("form")
      ? this.element
      : this.element.closest("form");

    if (!form) return;

    const FilePond = this.FilePond || await loadFilePond();
    const pondCandidates = form.querySelectorAll(
      "input[id^='post_medias_'], input.filepond-transparent, " +
      ".filepond--root"
    );
    const ponds = Array.from(pondCandidates)
      .map(element => FilePond.find(element))
      .filter((pond, index, list) => pond && list.indexOf(pond) === index);

    await Promise.all(ponds.map(pond => pond.removeFiles()));

    $(form).find("#poll-options input").val("");
    form.reset();
    this.resetQuillInput();

    await new Promise(resolve => requestAnimationFrame(resolve));
  }

  updateSharePostDisplay(form, index) {
    const shareOptions = form?.querySelectorAll(`input[id^="share_type_${index}_"]`);

    const selectedOptions = Array.from(shareOptions || [])
      .filter(option => option.checked)
      .map(option => option.nextElementSibling?.textContent.trim())
      .filter(Boolean);

    const display = form?.querySelector("#sharePostOptions .share_types");

    if (display) {
      display.textContent = selectedOptions.join(", ") || "Everyone";
    }
  }

  updateReplyOptionDisplay(form) {
    const dropdown = form?.querySelector("[data-controller~=\"dropdown\"]");
    if (!dropdown) return;

    const selectedOptions = Array.from(dropdown.querySelectorAll(".reply-opt-select .form-check-input"))
      .filter(option => option.checked)
      .map(option => option.nextElementSibling?.textContent.trim())
      .filter(Boolean);

    const display = dropdown.querySelector(".selected-value-display");
    if (display) {
      display.textContent = selectedOptions.join(", ") || "Select Reply Options";
    }
  }

  resetQuillInput(focus = false) {
    const quillController =
      this.application.getControllerForElementAndIdentifier(
        this.element.querySelector("[data-controller='quill']"),
        "quill"
      );

    if (quillController) {
      quillController.clear();
      if (focus) {
        quillController.quill.focus();
      }
    }
  }

  async addImageToFilePond(event) {
    const FilePond = await loadFilePond();
    const form = this.element.closest("form");
    const input = form.querySelector("[id^=\"post_medias_\"]");

    if (!input) return;

    input.classList.remove("d-none");

    const pond = FilePond.find(input);

    if (!pond) {
      console.error("FilePond instance not found");
      return;
    }

    const files = event.detail.files || [];

    await Promise.all(
      files.map(file => pond.addFile(file))
    );
  }

  showAlert(title, message, icon) {
    return Swal.fire({
      customClass: {
        popup:
          "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
        htmlContainer: "text-black-paint text-white"
      },
      animation: false,
      title: title,
      text: message,
      icon: icon,
      confirmButtonText: "OK",
      showCancelButton: true,
      cancelButtonText: "Cancel"
    });
  }

  removeScheduleTime(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    this.clearSchedule(index);

    const dateInput = event.currentTarget
      .closest(".post-form-wrapper")
      ?.querySelector(`[data-index="${index}"][data-flatpickr-type-value="datetime"]`);

    if (dateInput) {
      const flatpickrController =
        this.application.getControllerForElementAndIdentifier(
          dateInput,
          "flatpickr"
        );

      flatpickrController?.clear();
    }
  }

  clearSchedule(index, dateInput = null) {
    $(`#schedule_time_${index}`).text("");
    $(`#set_schedule_time_${index}`).addClass("d-none");

    const input = document.getElementById(`scheduled_at_${index}`);
    if (input) {
      input.value = "";
    }

    this.clearPendingSchedule(dateInput);
  }

  clearPendingSchedule(dateInput) {
    if (!dateInput) return;

    delete dateInput.dataset.pendingScheduledAt;
    delete dateInput.dataset.pendingScheduleDisplay;

    dateInput
      ?.closest(".modal")
      ?.querySelector(".confirm-schedule-button")
      ?.classList.add("disabled");
  }

  validatePollOption(event) {
    $(event.currentTarget)
      .closest("[id^=\"post-poll-\"]")
      .find("input[name*=\"[poll_options_attributes]\"][name$=\"[answer]\"]")
      .each(function () {
        $(this).valid();
      });
  }

  showLoading() {
    const submitButton = this.element.querySelector(".post_submit");
    submitButton.classList.add("loading");
    submitButton.querySelector(".button-loader-spinner").classList.remove("d-none");
  }

  hideLoading() {
    this.hideReplyForm(event);
    const submitButton = this.element.querySelector(".post_submit");
    submitButton.classList.remove("loading");
    submitButton.querySelector(".button-loader-spinner").classList.add("d-none");
  }
}

function handleExclusiveSelection(
  selectedValue,
  checkboxes,
  everyoneCheckbox,
  onlyMeCheckbox
) {
  const hasChecked = [...checkboxes].some(checkbox => checkbox.checked);

  if (!hasChecked) {
    if (everyoneCheckbox) {
      everyoneCheckbox.checked = true;
    }
    return;
  }

  if (selectedValue === "everyone") {
    uncheckAllExcept(checkboxes, everyoneCheckbox);
    return;
  }

  if (selectedValue === "only_me") {
    uncheckAllExcept(checkboxes, onlyMeCheckbox);
    return;
  }

  uncheckExclusiveOptions(everyoneCheckbox, onlyMeCheckbox);
}

function uncheckAllExcept(checkboxes, allowedCheckbox) {
  for (const cb of checkboxes) {
    if (cb !== allowedCheckbox) {
      cb.checked = false;
    }
  }
}

function uncheckExclusiveOptions(...checkboxes) {
  for (const cb of checkboxes) {
    if (cb?.checked) cb.checked = false;
  }
}
